/**
 * @file Generated by js-routes 2.3.6. Based on Rails 8.1.2 routes of Hunter::Application.
 * @version 9a5c6be69bab145570bbee6c0d42c498440b613196821e54d1b97f601dc8d29b
 * @see https://github.com/railsware/js-routes
 */
// eslint-disable-next-line
const __jsr = (
// eslint-disable-next-line
() => {
    const hasProp = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    const ModuleReferences = {
        CJS: {
            define(routes) {
                if (module) {
                    module.exports = routes;
                }
            },
            isSupported() {
                return typeof module === "object";
            },
        },
        AMD: {
            define(routes) {
                if (define) {
                    define([], function () {
                        return routes;
                    });
                }
            },
            isSupported() {
                return typeof define === "function" && !!define.amd;
            },
        },
        UMD: {
            define(routes) {
                if (ModuleReferences.AMD.isSupported()) {
                    ModuleReferences.AMD.define(routes);
                }
                else {
                    if (ModuleReferences.CJS.isSupported()) {
                        try {
                            ModuleReferences.CJS.define(routes);
                        }
                        catch (error) {
                            if (error.name !== "TypeError")
                                throw error;
                        }
                    }
                }
            },
            isSupported() {
                return (ModuleReferences.AMD.isSupported() ||
                    ModuleReferences.CJS.isSupported());
            },
        },
        ESM: {
            define() {
                // Module can only be defined using ruby code generation
            },
            isSupported() {
                // Its impossible to check if "export" keyword is supported
                return true;
            },
        },
        NIL: {
            define() {
                // Defined using const __jsr = 
            },
            isSupported() {
                return true;
            },
        },
        DTS: {
            // Acts the same as ESM
            define(routes) {
                ModuleReferences.ESM.define(routes);
            },
            isSupported() {
                return ModuleReferences.ESM.isSupported();
            },
        },
    };
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
        "script_name",
    ];
    class UtilsClass {
        constructor() {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "_options",
                serializer: null || this.default_serializer.bind(this),
            };
        }
        default_serializer(value, prefix) {
            if (!prefix && !this.is_object(value)) {
                throw new Error("Url parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                for (const element of value) {
                    result.push(this.default_serializer(element, prefix + "[]"));
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (prefix) {
                        key = prefix + "[" + key + "]";
                    }
                    const subvalue = this.default_serializer(prop, key);
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else {
                result.push(this.is_not_nullable(value) ||
                    false
                    ? encodeURIComponent(prefix) +
                        "=" +
                        encodeURIComponent("" + (value !== null && value !== void 0 ? value : ""))
                    : encodeURIComponent(prefix));
            }
            return result.join("&");
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) &&
                    !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (false &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            // eslint-disable-next-line prefer-const
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            let { trailing_slash, anchor, script_name } = keyword_parameters;
            const missing_params = required_params.filter((param) => !hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            if (anchor) {
                result += "#" + anchor;
            }
            if (script_name) {
                const last_index = script_name.length - 1;
                if (script_name[last_index] == "/" && result[0] == "/") {
                    script_name = script_name.slice(0, last_index);
                }
                result = script_name + result;
            }
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                    break;
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        configure(new_config) {
            if (new_config.prefix) {
                console.warn("JsRoutes configuration prefix option is deprecated in favor of default_url_options.script_name.");
            }
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        is_module_supported(name) {
            return ModuleReferences[name].isSupported();
        }
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        }
        define_module(name, module) {
            this.ensure_module_supported(name);
            ModuleReferences[name].define(module);
            return module;
        }
    }
    const utils = new UtilsClass();
    // We want this helper name to be short
    const __jsr = {
        r(parts_table, route_spec, absolute) {
            return utils.route(parts_table, route_spec, absolute);
        },
    };
    return utils.define_module("ESM", {
        ...__jsr,
        configure: (config) => {
            return utils.configure(config);
        },
        config: () => {
            return utils.config();
        },
        serialize: (object) => {
            return utils.serialize(object);
        },
        ...{},
    });
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

/**
 * Generates rails route to
 * (/:locale)/about(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const about_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"about"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /account_exports/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_export_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_exports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /messages/activity(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activity_messages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"activity"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/account_exports/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_account_export_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"account_exports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/account_exports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_account_exports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"account_exports"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/activity_logs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_activity_log_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"activity_logs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/activity_logs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_activity_logs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"activity_logs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/admin_user_notes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_admin_user_note_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"admin_user_notes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/admin_user_notes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_admin_user_notes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"admin_user_notes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/api_keys/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_api_key_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"api_keys"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/api_keys(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_api_keys_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"api_keys"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/banned_domains/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_banned_domain_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"banned_domains"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/banned_domains(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_banned_domains_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"banned_domains"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/billing_informations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_billing_information_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"billing_informations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/billing_informations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_billing_informations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"billing_informations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/bulk_finders/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_bulk_finder_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"bulk_finders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/bulk_finders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_bulk_finders_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"bulk_finders"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/bulk_searches/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_bulk_search_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"bulk_searches"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/bulk_searches(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_bulk_searches_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"bulk_searches"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/bulk_verifications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_bulk_verification_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"bulk_verifications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/bulk_verifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_bulk_verifications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"bulk_verifications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/calls/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_call_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"calls"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/calls(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_calls_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"calls"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/campaigns/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_campaign_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/campaign_email_accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_campaign_email_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaign_email_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/campaign_email_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_campaign_email_accounts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaign_email_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/campaigns/:campaign_id/messages(.:format)
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_campaign_messages_path = /*#__PURE__*/ __jsr.r({"campaign_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/campaign_recipients/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_campaign_recipient_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaign_recipients"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/campaign_recipients(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_campaign_recipients_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaign_recipients"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/campaigns/:campaign_id/reset(.:format)
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_campaign_reset_path = /*#__PURE__*/ __jsr.r({"campaign_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/campaigns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_campaigns_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/cancellation_reasons/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_cancellation_reason_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"cancellation_reasons"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/cancellation_reasons(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_cancellation_reasons_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"cancellation_reasons"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/claimed_emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_claimed_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"claimed_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/claimed_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_claimed_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"claimed_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/claimed_emails/bulks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_claimed_emails_bulk_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"claimed_emails"],[2,[7,"/"],[2,[6,"bulks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/claimed_emails/bulks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_claimed_emails_bulks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"claimed_emails"],[2,[7,"/"],[2,[6,"bulks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/claimed_emails/bulks/destroy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_claimed_emails_bulks_destroy_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"claimed_emails"],[2,[7,"/"],[2,[6,"bulks"],[2,[7,"/"],[2,[6,"destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/connected_apps/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_connected_app_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"connected_apps"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/connected_apps(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_connected_apps_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"connected_apps"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/credit_cards/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_credit_card_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"credit_cards"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/credit_cards(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_credit_cards_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"credit_cards"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/custom_domains/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_custom_domain_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"custom_domains"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/custom_domains(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_custom_domains_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"custom_domains"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/custom_plans/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_custom_plan_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"custom_plans"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/custom_plans(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_custom_plans_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"custom_plans"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/dev_info/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_dev_info_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dev_info"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/dev_info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_dev_info_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dev_info"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/disputes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_dispute_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"disputes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/disputes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_disputes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"disputes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_email_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_email_accounts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_interactions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_email_interactions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_interactions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_templates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_email_template_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_template_tags/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_email_template_tag_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_template_tags"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_template_tags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_email_template_tags_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_template_tags"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_email_templates_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/firewall/ban/:ip(.:format)
 * @param {any} ip
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_firewall_path = /*#__PURE__*/ __jsr.r({"ip":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"firewall"],[2,[7,"/"],[2,[6,"ban"],[2,[7,"/"],[2,[3,"ip"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/firewall/destroy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_firewall_destroy_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"firewall"],[2,[7,"/"],[2,[6,"destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/follow_ups/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_follow_up_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"follow_ups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/follow_ups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_follow_ups_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"follow_ups"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/global_notifications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_global_notification_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"global_notifications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/global_notifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_global_notifications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"global_notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/incoming_messages/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_incoming_message_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"incoming_messages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/incoming_messages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_incoming_messages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"incoming_messages"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/invoices/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_invoice_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/invoices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_invoices_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/ips/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_ip_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ips"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ip_visits/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_ip_visit_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ip_visits"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ip_visits(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_ip_visits_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ip_visits"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/ips(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_ips_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ips"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/leads/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_lead_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/lead_custom_attributes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_lead_custom_attribute_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"lead_custom_attributes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/lead_custom_attributes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_lead_custom_attributes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"lead_custom_attributes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/leads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_leads_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"leads"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/leads_imports/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_leads_import_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"leads_imports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/leads_imports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_leads_imports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"leads_imports"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/leads_lists/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_leads_list_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"leads_lists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/leads_list/dynamic_lists/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_leads_list_dynamic_list_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"leads_list"],[2,[7,"/"],[2,[6,"dynamic_lists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/leads_list/dynamic_lists(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_leads_list_dynamic_lists_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"leads_list"],[2,[7,"/"],[2,[6,"dynamic_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/leads_list/static_lists/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_leads_list_static_list_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"leads_list"],[2,[7,"/"],[2,[6,"static_lists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/leads_list/static_lists(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_leads_list_static_lists_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"leads_list"],[2,[7,"/"],[2,[6,"static_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/leads_lists(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_leads_lists_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"leads_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/link_visits/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_link_visit_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"link_visits"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/link_visits(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_link_visits_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"link_visits"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/managed_domains/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_managed_domain_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"managed_domains"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/managed_domain_owners/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_managed_domain_owner_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"managed_domain_owners"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/managed_domain_owners(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_managed_domain_owners_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"managed_domain_owners"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/managed_domains(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_managed_domains_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"managed_domains"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/managed_mailboxes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_managed_mailbox_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"managed_mailboxes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/managed_mailboxes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_managed_mailboxes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"managed_mailboxes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/messages/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_message_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/message_templates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_message_template_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"message_templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/message_templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_message_templates_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"message_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/messages/:id/spam_assassin_report(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_messages_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"spam_assassin_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/monitored_signals/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_monitored_signal_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"monitored_signals"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/monitored_signals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_monitored_signals_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"monitored_signals"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/new_accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_new_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"new_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/new_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_new_accounts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"new_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/onboarding_steps/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_onboarding_step_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"onboarding_steps"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/onboarding_steps(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_onboarding_steps_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"onboarding_steps"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/orders/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/order_items/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_order_item_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"order_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/order_items(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_order_items_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"order_items"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/orders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_orders_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"orders"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/outgoing_messages/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_outgoing_message_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"outgoing_messages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/outgoing_messages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_outgoing_messages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"outgoing_messages"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/outreach_domain_unsubscriptions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_outreach_domain_unsubscription_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"outreach_domain_unsubscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/outreach_domain_unsubscriptions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_outreach_domain_unsubscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"outreach_domain_unsubscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/outreach_unsubscriptions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_outreach_unsubscription_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"outreach_unsubscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/outreach_unsubscriptions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_outreach_unsubscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"outreach_unsubscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/paused_subscriptions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_paused_subscription_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"paused_subscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/paused_subscriptions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_paused_subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"paused_subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/pixel_visits/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_pixel_visit_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"pixel_visits"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/pixel_visits(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_pixel_visits_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"pixel_visits"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/postmark_events/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_postmark_event_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"postmark_events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/postmark_events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_postmark_events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"postmark_events"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/promo_codes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_promo_code_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"promo_codes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/promo_codes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_promo_codes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"promo_codes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/requests/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_request_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"requests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/requests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_requests_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"requests"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/requests_packs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_requests_pack_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"requests_packs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/requests_packs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_requests_packs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"requests_packs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_root_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/saved_leads/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_saved_lead_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"saved_leads"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/saved_leads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_saved_leads_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"saved_leads"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/subscriptions/:id/cancel(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_subscriptions_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/subscriptions/update(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_subscriptions_update_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/teams/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_team_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/teams/:team_id/calls(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_team_calls_path = /*#__PURE__*/ __jsr.r({"team_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"calls"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/teams/:team_id/calls_breakdown(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_team_calls_breakdown_path = /*#__PURE__*/ __jsr.r({"team_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"calls_breakdown"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/teams/:team_id/entitlements/:id(.:format)
 * @param {any} team_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_team_entitlement_path = /*#__PURE__*/ __jsr.r({"team_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"entitlements"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/teams/:team_id/entitlements(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_team_entitlements_path = /*#__PURE__*/ __jsr.r({"team_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"entitlements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/team_invites/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_team_invite_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"team_invites"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/team_invites(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_team_invites_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"team_invites"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/team_permissions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_team_permission_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"team_permissions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/team_permissions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_team_permissions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"team_permissions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/teams/:team_id/usage_charts(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_team_usage_charts_path = /*#__PURE__*/ __jsr.r({"team_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"usage_charts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/teams/:team_id/usages(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_team_usages_path = /*#__PURE__*/ __jsr.r({"team_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"usages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/teams(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_teams_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"teams"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/teams/invite(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_teams_invite_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"invite"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/teams/move-to-new-team(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_teams_move_to_new_team_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"move-to-new-team"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/teams/update-owner(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_teams_update_owner_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"update-owner"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/usages/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_usage_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"usages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/usages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_usages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"usages"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:user_id/admin_user_notes/:id(.:format)
 * @param {any} user_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_user_admin_user_note_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"admin_user_notes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:user_id/admin_user_notes(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_user_admin_user_notes_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"admin_user_notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:user_id/calls(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_user_calls_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"calls"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:user_id/calls_breakdown(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_user_calls_breakdown_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"calls_breakdown"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/user_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_user_data_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"user_data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/user_data/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_user_datum_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"user_data"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/user_previous_emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_user_previous_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"user_previous_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/user_previous_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_user_previous_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"user_previous_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:user_id/usage_charts(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_user_usage_charts_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"usage_charts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:user_id/usages(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_user_usages_path = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"usages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/reset-password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_users_reset_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"reset-password"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/screen(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_users_screen_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"screen"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_users_search_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/webhooks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_webhook_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/webhooks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_webhooks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"webhooks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/affiliate-program(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const affiliate_program_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"affiliate-program"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /affiliate-program/terms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const affiliate_program_terms_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"affiliate-program"],[2,[7,"/"],[2,[6,"terms"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/affiliate-program/thank-you(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const affiliate_program_thank_you_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"affiliate-program"],[2,[7,"/"],[2,[6,"thank-you"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/ai-cold-email-assistant(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_cold_email_assistant_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"ai-cold-email-assistant"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /ai-cold-email-guide(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_cold_email_guide_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ai-cold-email-guide"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * (/:locale)/ai-email-quiz(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ai_email_quiz_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"ai-email-quiz"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /email_accounts/:id/aliases(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const aliases_email_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"email_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"aliases"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/welcome/annual-discount(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const annual_discount_welcome_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"welcome"],[2,[7,"/"],[2,[6,"annual-discount"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /:api_version/leads_lists/:id/merge(.:format)
 * @param {any} api_version
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_path = /*#__PURE__*/ __jsr.r({"api_version":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"api_version"],[2,[7,"/"],[2,[6,"leads_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"merge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:api_version/account(.:format)
 * @param {any} api_version
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_account_path = /*#__PURE__*/ __jsr.r({"api_version":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"api_version"],[2,[7,"/"],[2,[6,"account"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:api_version/account-stats(.:format)
 * @param {any} api_version
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_account_stats_path = /*#__PURE__*/ __jsr.r({"api_version":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"api_version"],[2,[7,"/"],[2,[6,"account-stats"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:api_version/campaigns/:campaign_id/recipients(.:format)
 * @param {any} api_version
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_campaign_recipients_path = /*#__PURE__*/ __jsr.r({"api_version":{"r":true},"campaign_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"api_version"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"recipients"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:api_version/campaigns/:campaign_id/start(.:format)
 * @param {any} api_version
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_campaign_start_path = /*#__PURE__*/ __jsr.r({"api_version":{"r":true},"campaign_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"api_version"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"start"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:api_version/campaigns(.:format)
 * @param {any} api_version
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_campaigns_path = /*#__PURE__*/ __jsr.r({"api_version":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"api_version"],[2,[7,"/"],[2,[6,"campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:api_version/combined/find(.:format)
 * @param {any} api_version
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_combined_find_path = /*#__PURE__*/ __jsr.r({"api_version":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"api_version"],[2,[7,"/"],[2,[6,"combined"],[2,[7,"/"],[2,[6,"find"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:api_version/companies/find(.:format)
 * @param {any} api_version
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_companies_find_path = /*#__PURE__*/ __jsr.r({"api_version":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"api_version"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"find"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:api_version/discover(.:format)
 * @param {any} api_version
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_discover_path = /*#__PURE__*/ __jsr.r({"api_version":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"api_version"],[2,[7,"/"],[2,[6,"discover"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/api/docs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_docs_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"docs"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /api-documentation/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_documentation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api-documentation"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api-documentation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_documentation_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api-documentation"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api-documentation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_documentation_index_root_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api-documentation"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /:api_version/domain-count(.:format)
 * @param {any} api_version
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_domain_count_path = /*#__PURE__*/ __jsr.r({"api_version":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"api_version"],[2,[7,"/"],[2,[6,"domain-count"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:api_version/domain-search(.:format)
 * @param {any} api_version
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_domain_search_path = /*#__PURE__*/ __jsr.r({"api_version":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"api_version"],[2,[7,"/"],[2,[6,"domain-search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:api_version/domains-suggestion(.:format)
 * @param {any} api_version
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_domains_suggestion_path = /*#__PURE__*/ __jsr.r({"api_version":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"api_version"],[2,[7,"/"],[2,[6,"domains-suggestion"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:api_version/email-count(.:format)
 * @param {any} api_version
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_email_count_path = /*#__PURE__*/ __jsr.r({"api_version":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"api_version"],[2,[7,"/"],[2,[6,"email-count"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:api_version/email-finder(.:format)
 * @param {any} api_version
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_email_finder_path = /*#__PURE__*/ __jsr.r({"api_version":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"api_version"],[2,[7,"/"],[2,[6,"email-finder"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:api_version/email-insight(.:format)
 * @param {any} api_version
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_email_insight_path = /*#__PURE__*/ __jsr.r({"api_version":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"api_version"],[2,[7,"/"],[2,[6,"email-insight"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:api_version/email-verifier(.:format)
 * @param {any} api_version
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_email_verifier_path = /*#__PURE__*/ __jsr.r({"api_version":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"api_version"],[2,[7,"/"],[2,[6,"email-verifier"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/api(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"api"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/api(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_index_root_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"api"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /api-keys/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_key_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api-keys"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api-keys(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_keys_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api-keys"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /connected-apps/api_keys/create(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_keys_create_connected_apps_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"connected-apps"],[2,[7,"/"],[2,[6,"api_keys"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:api_version/leads/:id(.:format)
 * @param {any} api_version
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_lead_path = /*#__PURE__*/ __jsr.r({"api_version":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"api_version"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:api_version/leads(.:format)
 * @param {any} api_version
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_leads_path = /*#__PURE__*/ __jsr.r({"api_version":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"api_version"],[2,[7,"/"],[2,[6,"leads"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:api_version/leads_custom_attributes/:id(.:format)
 * @param {any} api_version
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_leads_custom_attribute_path = /*#__PURE__*/ __jsr.r({"api_version":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"api_version"],[2,[7,"/"],[2,[6,"leads_custom_attributes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:api_version/leads_custom_attributes(.:format)
 * @param {any} api_version
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_leads_custom_attributes_path = /*#__PURE__*/ __jsr.r({"api_version":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"api_version"],[2,[7,"/"],[2,[6,"leads_custom_attributes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:api_version/leads_lists/:id(.:format)
 * @param {any} api_version
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_leads_list_path = /*#__PURE__*/ __jsr.r({"api_version":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"api_version"],[2,[7,"/"],[2,[6,"leads_lists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:api_version/leads_lists(.:format)
 * @param {any} api_version
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_leads_lists_path = /*#__PURE__*/ __jsr.r({"api_version":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"api_version"],[2,[7,"/"],[2,[6,"leads_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:api_version/messages(.:format)
 * @param {any} api_version
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_messages_path = /*#__PURE__*/ __jsr.r({"api_version":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"api_version"],[2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:api_version/people/find(.:format)
 * @param {any} api_version
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_people_find_path = /*#__PURE__*/ __jsr.r({"api_version":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"api_version"],[2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[6,"find"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/api/v1/docs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v1_docs_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"docs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/api/v2/docs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_v2_docs_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"docs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /:api_version/webhooks/:id(.:format)
 * @param {any} api_version
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_webhook_path = /*#__PURE__*/ __jsr.r({"api_version":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"api_version"],[2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:api_version/webhooks(.:format)
 * @param {any} api_version
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_webhooks_path = /*#__PURE__*/ __jsr.r({"api_version":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"api_version"],[2,[7,"/"],[2,[6,"webhooks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /bulk-finders/:id/archive(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archive_bulk_finder_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bulk-finders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /bulk-searches/:id/archive(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archive_bulk_search_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bulk-searches"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /bulk-verifications/:id/archive(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archive_bulk_verification_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bulk-verifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/:id/archive(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archive_campaign_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/:id/audience/all(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audience_all_campaign_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"all"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/:id/audience/cancel(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audience_cancel_campaign_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/:id/audience/export(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audience_export_campaign_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/:id/audience/removed-recipients(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audience_removed_recipients_campaign_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"removed-recipients"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/:id/audience/verify(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audience_verify_campaign_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/failure(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_failure_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"failure"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /auth/gmail/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_gmail_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"gmail"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/google/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_google_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"google"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/hubspot/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_hubspot_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"hubspot"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/linkedin/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_linkedin_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"linkedin"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/outlook/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_outlook_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"outlook"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/salesforce/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_salesforce_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"salesforce"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/zoho_au/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_zoho_au_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"zoho_au"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/zoho/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_zoho_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"zoho"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/zoho_eu/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_zoho_eu_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"zoho_eu"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/zoho_in/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_zoho_in_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"zoho_in"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/claim/authenticate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authenticate_claim_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"claim"],[2,[7,"/"],[2,[6,"authenticate"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /author-finder(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const author_finder_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"author-finder"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /subscriptions/auto-purchase-settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auto_purchase_settings_subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"auto-purchase-settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/b2b-database(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const b2b_database_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"b2b-database"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /billing-information/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billing_information_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"billing-information"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /billing-information(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billing_information_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"billing-information"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /bulk(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"bulk"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /discover/saved-searches/bulk(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_discover_saved_searches_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"discover"],[2,[7,"/"],[2,[6,"saved-searches"],[2,[7,"/"],[2,[6,"bulk"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email_accounts/bulk(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_email_accounts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_accounts"],[2,[7,"/"],[2,[6,"bulk"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:api_version/leads/bulk/exist(.:format)
 * @param {any} api_version
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_exist_api_leads_path = /*#__PURE__*/ __jsr.r({"api_version":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"api_version"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"exist"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /bulk-finders/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_finder_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bulk-finders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /bulk-finders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_finders_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"bulk-finders"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /bulk-searches/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_search_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bulk-searches"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /bulk-searches(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_searches_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"bulk-searches"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /email_accounts/bulk/subscription(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_subscription_email_accounts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_accounts"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"subscription"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /bulk-verifications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_verification_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bulk-verifications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /bulk-verifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_verifications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"bulk-verifications"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * (/:locale)/bulks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulks_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"bulks"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /bulks/author-finder(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulks_author_finder_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"bulks"],[2,[7,"/"],[2,[6,"author-finder"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/bulks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulks_root_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"bulks"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /bulk-searches/buttons(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const buttons_bulk_searches_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"bulk-searches"],[2,[7,"/"],[2,[6,"buttons"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/visitors/calculate_credit_pack_price(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calculate_credit_pack_price_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"visitors"],[2,[7,"/"],[2,[6,"calculate_credit_pack_price"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/visitors/calculate_data_platform_price(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calculate_data_platform_price_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"visitors"],[2,[7,"/"],[2,[6,"calculate_data_platform_price"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaign_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/:campaign_id/ab_test_settings(.:format)
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaign_ab_test_settings_path = /*#__PURE__*/ __jsr.r({"campaign_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"ab_test_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/:campaign_id/ai_settings(.:format)
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaign_ai_settings_path = /*#__PURE__*/ __jsr.r({"campaign_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"ai_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/:campaign_id/audience(.:format)
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaign_audience_path = /*#__PURE__*/ __jsr.r({"campaign_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"audience"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/:campaign_id/content(.:format)
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaign_content_path = /*#__PURE__*/ __jsr.r({"campaign_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"content"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/:campaign_id/follow_ups/:id(.:format)
 * @param {any} campaign_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaign_follow_up_path = /*#__PURE__*/ __jsr.r({"campaign_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"follow_ups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/:campaign_id/follow_ups(.:format)
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaign_follow_ups_path = /*#__PURE__*/ __jsr.r({"campaign_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"follow_ups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/:campaign_id/messages(.:format)
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaign_messages_path = /*#__PURE__*/ __jsr.r({"campaign_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/:campaign_id/next_send_at(.:format)
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaign_next_send_at_path = /*#__PURE__*/ __jsr.r({"campaign_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"next_send_at"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/:campaign_id/personas(.:format)
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaign_personas_path = /*#__PURE__*/ __jsr.r({"campaign_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"personas"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/:campaign_id/recipients/:id(.:format)
 * @param {any} campaign_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaign_recipient_path = /*#__PURE__*/ __jsr.r({"campaign_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"recipients"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/:campaign_id/recipients(.:format)
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaign_recipients_path = /*#__PURE__*/ __jsr.r({"campaign_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"recipients"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/:campaign_id/send-test(.:format)
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaign_send_test_path = /*#__PURE__*/ __jsr.r({"campaign_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"send-test"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/:campaign_id/settings(.:format)
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaign_settings_path = /*#__PURE__*/ __jsr.r({"campaign_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/:campaign_id/start(.:format)
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaign_start_path = /*#__PURE__*/ __jsr.r({"campaign_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"start"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/:campaign_id/stats(.:format)
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaign_stats_path = /*#__PURE__*/ __jsr.r({"campaign_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/:campaign_id/webhooks/:id(.:format)
 * @param {any} campaign_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaign_webhook_path = /*#__PURE__*/ __jsr.r({"campaign_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/:campaign_id/webhooks(.:format)
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaign_webhooks_path = /*#__PURE__*/ __jsr.r({"campaign_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"webhooks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaigns_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * (/:locale)/api/campaigns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaigns_api_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /email_accounts/:id/campaigns(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaigns_email_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"email_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/email-accounts-center(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaigns_email_accounts_center_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"email-accounts-center"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/inbox/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaigns_inbox_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/inbox(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaigns_inbox_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"inbox"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/latest(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaigns_latest_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"latest"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/leads_sample(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaigns_leads_sample_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"leads_sample"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/outreach_domain_unsubscriptions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaigns_outreach_domain_unsubscription_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"outreach_domain_unsubscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/outreach_unsubscriptions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaigns_outreach_unsubscription_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"outreach_unsubscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/queue/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaigns_queue_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"queue"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/queue(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaigns_queue_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"queue"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/reporting(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaigns_reporting_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"reporting"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/reporting/details(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaigns_reporting_details_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/reporting/details/campaigns/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaigns_reporting_details_campaign_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"details"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/reporting/details/team_members/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaigns_reporting_details_team_member_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"details"],[2,[7,"/"],[2,[6,"team_members"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/reporting/email_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaigns_reporting_email_accounts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"email_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/reporting/email_accounts/details(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaigns_reporting_email_accounts_details_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"email_accounts"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/reporting/email_accounts/leaderboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaigns_reporting_email_accounts_leaderboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"email_accounts"],[2,[7,"/"],[2,[6,"leaderboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/reporting/email_domains(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaigns_reporting_email_domains_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"email_domains"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/reporting/email_domains/details(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaigns_reporting_email_domains_details_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"email_domains"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/reporting/email_domains/leaderboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaigns_reporting_email_domains_leaderboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"email_domains"],[2,[7,"/"],[2,[6,"leaderboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/reporting/graph(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaigns_reporting_graph_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"graph"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/reporting/leaderboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaigns_reporting_leaderboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"leaderboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/reporting/overview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaigns_reporting_overview_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"overview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/reporting/team_members(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaigns_reporting_team_members_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"team_members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/reporting/team_members/details(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaigns_reporting_team_members_details_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"team_members"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/reporting/team_members/leaderboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaigns_reporting_team_members_leaderboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"team_members"],[2,[7,"/"],[2,[6,"leaderboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/unsubscriptions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaigns_unsubscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"unsubscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /bulk-verifications/:id/cancel(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_bulk_verification_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bulk-verifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /subscriptions/cancel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/cancel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_user_registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /subscriptions/cancellation-confirmation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancellation_confirmation_subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"cancellation-confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /cancellation-reasons/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancellation_reason_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cancellation-reasons"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /cancellation-reasons(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancellation_reasons_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"cancellation-reasons"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /email_accounts/capacities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const capacities_email_accounts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_accounts"],[2,[7,"/"],[2,[6,"capacities"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/careers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const careers_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"careers"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /checkout/buy_credits_pack(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkout_buy_credits_pack_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"buy_credits_pack"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /checkout/cost_estimation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkout_cost_estimation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"cost_estimation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /subscriptions/checkout/email_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkout_email_accounts_subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"email_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /checkout/get_more_credits(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkout_get_more_credits_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"get_more_credits"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /checkout/posthog_events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkout_posthog_events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"posthog_events"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /subscriptions/checkout/review_order(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkout_review_order_subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"review_order"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /subscriptions/checkout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkout_subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"checkout"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /checkout/success_plan(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkout_success_plan_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"success_plan"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /checkout/upgrade_plan(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkout_upgrade_plan_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"upgrade_plan"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/chrome(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chrome_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"chrome"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/chrome(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chrome_index_root_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"chrome"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /cities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cities_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"cities"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /subscriptions/claim-discount(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const claim_discount_subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"claim-discount"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/claim(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const claim_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"claim"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/integrations/clay(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clay_integrations_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"clay"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/:id/cleanup(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cleanup_campaign_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cleanup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /notifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clear_notifications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /clearbit-api-alternative(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clearbit_api_alternative_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"clearbit-api-alternative"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * (/:locale)/clearbit-enrichment-api-alternative(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clearbit_enrichment_api_alternative_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"clearbit-enrichment-api-alternative"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/cold-email-campaigns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cold_email_campaigns_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"cold-email-campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/cold-email-software(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cold_email_software_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"cold-email-software"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/api/combined-enrichment(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const combined_enrichment_api_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"combined-enrichment"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/companies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companies_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"companies"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /:api_version/leads/companies(.:format)
 * @param {any} api_version
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companies_api_leads_path = /*#__PURE__*/ __jsr.r({"api_version":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"api_version"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"companies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /companies-imports/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companies_import_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"companies-imports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /companies-imports/:companies_import_id/configuration(.:format)
 * @param {any} companies_import_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companies_import_configuration_path = /*#__PURE__*/ __jsr.r({"companies_import_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"companies-imports"],[2,[7,"/"],[2,[3,"companies_import_id"],[2,[7,"/"],[2,[6,"configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /companies-imports/:companies_import_id/settings(.:format)
 * @param {any} companies_import_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companies_import_settings_path = /*#__PURE__*/ __jsr.r({"companies_import_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"companies-imports"],[2,[7,"/"],[2,[3,"companies_import_id"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /companies-imports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companies_imports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"companies-imports"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * (/:locale)/api/company-enrichment(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_enrichment_api_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"company-enrichment"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /company-lists/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_list_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company-lists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company-lists/bulk(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_list_bulk_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"company-lists"],[2,[7,"/"],[2,[6,"bulk"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company-lists/:company_list_id/favorite(.:format)
 * @param {any} company_list_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_list_favorite_path = /*#__PURE__*/ __jsr.r({"company_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company-lists"],[2,[7,"/"],[2,[3,"company_list_id"],[2,[7,"/"],[2,[6,"favorite"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company-lists/favorite(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_list_favorites_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"company-lists"],[2,[7,"/"],[2,[6,"favorite"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company-lists/folders/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_list_folder_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company-lists"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company-lists/folders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_list_folders_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"company-lists"],[2,[7,"/"],[2,[6,"folders"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company-lists/:company_list_id/memberships/:company_id(.:format)
 * @param {any} company_list_id
 * @param {any} company_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_list_membership_path = /*#__PURE__*/ __jsr.r({"company_list_id":{"r":true},"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company-lists"],[2,[7,"/"],[2,[3,"company_list_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[3,"company_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /company-lists(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const company_lists_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"company-lists"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /bulk-finders/:id/configuration(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const configuration_bulk_finder_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bulk-finders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /confirm_identity(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_identity_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"confirm_identity"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /confirm-identity(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_identity_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"confirm-identity"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /confirm-identity(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_identity_index_root_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"confirm-identity"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /bulk-searches/:id/confirmation(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirmation_bulk_search_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bulk-searches"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /connected-apps/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const connected_app_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"connected-apps"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /connected-apps(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const connected_apps_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"connected-apps"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /connected_apps/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const connected_apps_new_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"connected_apps"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/contact(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contact_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"contact"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /cookie-policy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cookie_policy_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"cookie-policy"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /bulk-searches/cost_estimate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cost_estimate_bulk_searches_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"bulk-searches"],[2,[7,"/"],[2,[6,"cost_estimate"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /email_accounts/:id/credentials/auth-code(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const credentials_auth_code_email_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"email_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"credentials"],[2,[7,"/"],[2,[6,"auth-code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /email_accounts/:id/credentials(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const credentials_email_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"email_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"credentials"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /credit-cards/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const credit_card_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"credit-cards"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /credit-cards(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const credit_cards_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"credit-cards"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * (/:locale)/contact-sales/data-platform(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_data_platform_plan_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"contact-sales"],[2,[7,"/"],[2,[6,"data-platform"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /custom_domains/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"custom_domains"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /custom_domains/:custom_domain_id/refresh(.:format)
 * @param {any} custom_domain_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_refresh_path = /*#__PURE__*/ __jsr.r({"custom_domain_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"custom_domains"],[2,[7,"/"],[2,[3,"custom_domain_id"],[2,[7,"/"],[2,[6,"refresh"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /custom_domains(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domains_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"custom_domains"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * (/:locale)/customers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customers_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"customers"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /leads/data-overview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_overview_leads_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"data-overview"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /lead/companies/data-overview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_overview_leads_companies_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lead"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"data-overview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/data-platform(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_platform_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"data-platform"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /data-processing-agreement(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_processing_agreement_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"data-processing-agreement"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /deliverability-guard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deliverability_guard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"deliverability-guard"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_user_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /discover/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discover_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discover"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /discover/ai_filter_refinements(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discover_ai_filter_refinements_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"discover"],[2,[7,"/"],[2,[6,"ai_filter_refinements"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /discover/ai_filters(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discover_ai_filters_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"discover"],[2,[7,"/"],[2,[6,"ai_filters"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/api/discover(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discover_api_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"discover"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /discover/bulk_searches(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discover_bulk_searches_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"discover"],[2,[7,"/"],[2,[6,"bulk_searches"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /discover/company_lists(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discover_company_lists_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"discover"],[2,[7,"/"],[2,[6,"company_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /discover/exports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discover_exports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"discover"],[2,[7,"/"],[2,[6,"exports"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /discover/people(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discover_people_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"discover"],[2,[7,"/"],[2,[6,"people"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /discover/people/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discover_person_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discover"],[2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /discover/saved-searches(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discover_saved_searches_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"discover"],[2,[7,"/"],[2,[6,"saved-searches"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /discover/search_name(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discover_search_name_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"discover"],[2,[7,"/"],[2,[6,"search_name"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /discover/suggestions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discover_suggestions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"discover"],[2,[7,"/"],[2,[6,"suggestions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /discover/views/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discover_view_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discover"],[2,[7,"/"],[2,[6,"views"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /discover/views(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discover_views_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"discover"],[2,[7,"/"],[2,[6,"views"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /discover(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discovers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"discover"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * (/:locale)/api/domain-search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const domain_search_api_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"domain-search"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/bulks/domain-search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const domain_search_bulks_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"bulks"],[2,[7,"/"],[2,[6,"domain-search"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/domain-search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const domain_search_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"domain-search"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/domain-search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const domain_search_index_root_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"domain-search"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /admin/invoices/download(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_admin_invoices_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /bulk-finders/:id/download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_bulk_finder_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bulk-finders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /bulk-searches/:id/download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_bulk_search_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bulk-searches"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /bulk-verifications/:id/download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_bulk_verification_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bulk-verifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /invoices/download(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_invoices_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/:id/duplicate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicate_campaign_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/:id/follow-ups/:step/duplicate(.:format)
 * @param {any} id
 * @param {any} step
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicate_follow_up_campaign_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"step":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"follow-ups"],[2,[7,"/"],[2,[3,"step"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/edge(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edge_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"edge"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/edge(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edge_index_root_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"edge"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /admin/account_exports/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_account_export_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"account_exports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/activity_logs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_activity_log_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"activity_logs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/admin_user_notes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_admin_user_note_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"admin_user_notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/api_keys/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_api_key_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"api_keys"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/banned_domains/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_banned_domain_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"banned_domains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/billing_informations/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_billing_information_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"billing_informations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/bulk_finders/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_bulk_finder_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"bulk_finders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/bulk_searches/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_bulk_search_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"bulk_searches"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/bulk_verifications/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_bulk_verification_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"bulk_verifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/calls/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_call_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"calls"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/campaigns/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_campaign_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/campaign_email_accounts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_campaign_email_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaign_email_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/campaign_recipients/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_campaign_recipient_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaign_recipients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/cancellation_reasons/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_cancellation_reason_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"cancellation_reasons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/claimed_emails/bulks/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_claimed_emails_bulk_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"claimed_emails"],[2,[7,"/"],[2,[6,"bulks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/connected_apps/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_connected_app_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"connected_apps"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/credit_cards/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_credit_card_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"credit_cards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/custom_plans/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_custom_plan_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"custom_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_templates/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_email_template_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_template_tags/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_email_template_tag_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_template_tags"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/follow_ups/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_follow_up_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"follow_ups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/global_notifications/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_global_notification_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"global_notifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/incoming_messages/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_incoming_message_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"incoming_messages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/invoices/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_invoice_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ips/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_ip_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ips"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ip_visits/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_ip_visit_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ip_visits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/leads/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_lead_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/lead_custom_attributes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_lead_custom_attribute_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"lead_custom_attributes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/leads_imports/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_leads_import_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"leads_imports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/leads_lists/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_leads_list_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"leads_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/leads_list/dynamic_lists/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_leads_list_dynamic_list_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"leads_list"],[2,[7,"/"],[2,[6,"dynamic_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/leads_list/static_lists/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_leads_list_static_list_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"leads_list"],[2,[7,"/"],[2,[6,"static_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/link_visits/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_link_visit_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"link_visits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/managed_domains/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_managed_domain_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"managed_domains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/managed_domain_owners/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_managed_domain_owner_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"managed_domain_owners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/managed_mailboxes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_managed_mailbox_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"managed_mailboxes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/message_templates/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_message_template_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"message_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/new_accounts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_new_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"new_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/onboarding_steps/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_onboarding_step_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"onboarding_steps"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/outgoing_messages/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_outgoing_message_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"outgoing_messages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/outreach_domain_unsubscriptions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_outreach_domain_unsubscription_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"outreach_domain_unsubscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/outreach_unsubscriptions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_outreach_unsubscription_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"outreach_unsubscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/paused_subscriptions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_paused_subscription_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"paused_subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/pixel_visits/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_pixel_visit_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"pixel_visits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/requests/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_request_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/requests_packs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_requests_pack_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"requests_packs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/saved_leads/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_saved_lead_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"saved_leads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/teams/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_team_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/teams/:team_id/entitlements/:id/edit(.:format)
 * @param {any} team_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_team_entitlement_path = /*#__PURE__*/ __jsr.r({"team_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"entitlements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/team_invites/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_team_invite_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"team_invites"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/team_permissions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_team_permission_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"team_permissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/usages/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_usage_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"usages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_user_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/user_data/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_user_datum_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"user_data"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/user_previous_emails/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_user_previous_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"user_previous_emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/webhooks/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_admin_webhook_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api-documentation/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_documentation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api-documentation"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:api_version/leads/:id/edit(.:format)
 * @param {any} api_version
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_lead_path = /*#__PURE__*/ __jsr.r({"api_version":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"api_version"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:api_version/leads_custom_attributes/:id/edit(.:format)
 * @param {any} api_version
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_leads_custom_attribute_path = /*#__PURE__*/ __jsr.r({"api_version":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"api_version"],[2,[7,"/"],[2,[6,"leads_custom_attributes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:api_version/leads_lists/:id/edit(.:format)
 * @param {any} api_version
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_api_leads_list_path = /*#__PURE__*/ __jsr.r({"api_version":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"api_version"],[2,[7,"/"],[2,[6,"leads_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /billing-information/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_billing_information_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"billing-information"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/:campaign_id/follow_ups/:id/edit(.:format)
 * @param {any} campaign_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_campaign_follow_up_path = /*#__PURE__*/ __jsr.r({"campaign_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"follow_ups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cancellation-reasons/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_cancellation_reason_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"cancellation-reasons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /company-lists/folders/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_company_list_folder_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"company-lists"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /custom_domains/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_custom_domain_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"custom_domains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /discover/people/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_discover_person_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discover"],[2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /leads/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_lead_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /leads/custom-attributes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_lead_custom_attribute_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"custom-attributes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /leads/tags/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_lead_tag_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /lead/companies/bulks/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_leads_companies_bulks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lead"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"bulks"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /lead/companies/tags/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_leads_companies_tag_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lead"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /lead/companies/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_leads_company_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lead"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /leads-lists/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_leads_list_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"leads-lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /leads-lists/folders/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_leads_list_folder_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"leads-lists"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /messages/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_message_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /messages/drafts/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_message_drafts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"drafts"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /message-templates/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_message_template_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"message-templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /message-templates/drafts/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_message_template_drafts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"message-templates"],[2,[7,"/"],[2,[6,"drafts"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /signals/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_signal_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"signals"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /connected-apps/smtp_imap/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_smtp_imap_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"connected-apps"],[2,[7,"/"],[2,[6,"smtp_imap"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /subscriptions/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/technologies/domains_lists/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_technologies_domains_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"technologies"],[2,[7,"/"],[2,[6,"domains_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/challenge/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_users_challenge_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"challenge"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /webhook_templates/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_webhook_template_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"webhook_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email_accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"email_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /email_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_accounts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_accounts"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /campaigns/:id/email-accounts(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_accounts_campaign_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"email-accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email_accounts/orders/subscription/:subscription_id(.:format)
 * @param {any} subscription_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_accounts_cancel_order_subscription_path = /*#__PURE__*/ __jsr.r({"subscription_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"email_accounts"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"subscription"],[2,[7,"/"],[2,[3,"subscription_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /email_accounts/checkout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_accounts_checkout_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_accounts"],[2,[7,"/"],[2,[6,"checkout"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /email_accounts/domains(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_accounts_domains_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_accounts"],[2,[7,"/"],[2,[6,"domains"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /email_accounts/mailboxes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_accounts_mailboxes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_accounts"],[2,[7,"/"],[2,[6,"mailboxes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /email_accounts/orders/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_accounts_order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"email_accounts"],[2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email_accounts/orders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_accounts_orders_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_accounts"],[2,[7,"/"],[2,[6,"orders"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /email_accounts/provisioning(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_accounts_provisioning_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_accounts"],[2,[7,"/"],[2,[6,"provisioning"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /email_accounts/subscriptions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_accounts_subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_accounts"],[2,[7,"/"],[2,[6,"subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /email-domains(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_domains_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email-domains"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /email-domains/bulk/subscription(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_domains_bulk_subscription_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email-domains"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"subscription"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email-domains/health-checks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_domains_health_checks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email-domains"],[2,[7,"/"],[2,[6,"health-checks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /email-domains/health-reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_domains_health_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email-domains"],[2,[7,"/"],[2,[6,"health-reports"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/api/email-finder(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_finder_api_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"email-finder"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/bulks/email-finder(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_finder_bulks_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"bulks"],[2,[7,"/"],[2,[6,"email-finder"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/email-finder(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_finder_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"email-finder"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/email-finder(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_finder_index_root_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"email-finder"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /billing-information/:id/email-notifications(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_notifications_billing_information_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"billing-information"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"email-notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/email_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_settings_campaigns_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"email_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_templates_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"templates"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/api/email-verifier(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_verifier_api_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"email-verifier"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/bulks/email-verifier(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_verifier_bulks_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"bulks"],[2,[7,"/"],[2,[6,"email-verifier"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/email-verifier(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_verifier_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"email-verifier"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/email-verifier(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_verifier_index_root_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"email-verifier"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /campaigns/engagement(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const engagement_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"engagement"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/engagement/views/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const engagement_view_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"engagement"],[2,[7,"/"],[2,[6,"views"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/engagement/views(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const engagement_views_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"engagement"],[2,[7,"/"],[2,[6,"views"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /leads/enrich(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enrich_leads_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"enrich"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/enterprise(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enterprise_plan_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"enterprise"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /:api_version/leads/exist(.:format)
 * @param {any} api_version
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exist_api_leads_path = /*#__PURE__*/ __jsr.r({"api_version":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"api_version"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"exist"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lead/companies/export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_leads_companies_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lead"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lead/companies/export_upgrade(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_upgrade_leads_companies_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lead"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"export_upgrade"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/extension(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const extension_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"extension"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/extension(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const extension_index_root_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"extension"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /find(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const find_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"find"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * (/:locale)/firefox(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const firefox_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"firefox"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/firefox(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const firefox_index_root_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"firefox"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /campaigns/:id/follow-ups/:step(.:format)
 * @param {any} id
 * @param {any} step
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const follow_up_step_campaign_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"step":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"follow-ups"],[2,[7,"/"],[2,[3,"step"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/:id/follow-ups(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const follow_ups_campaign_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"follow-ups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /403(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const forbidden_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"403"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /gdpr(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gdpr_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"gdpr"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * (/:locale)/integrations/gmail(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gmail_integrations_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"gmail"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /growth-starter(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const growth_starter_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"growth-starter"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /email_accounts/:id/health-report(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const health_report_email_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"email_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"health-report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /help/articles/10-google-sheets-add-on(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_articles_10_google_sheets_add_on_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[6,"10-google-sheets-add-on"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /help/articles/11-create-leads-in-hunter(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_articles_11_create_leads_in_hunter_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[6,"11-create-leads-in-hunter"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /help/articles/12-zapier-integration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_articles_12_zapier_integration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[6,"12-zapier-integration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /help/articles/13-zoho-crm-integration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_articles_13_zoho_crm_integration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[6,"13-zoho-crm-integration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /help/articles/15-confidence-score-and-email-verification(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_articles_15_confidence_score_and_email_verification_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[6,"15-confidence-score-and-email-verification"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /help/articles/16-hunter-s-firefox-add-on(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_articles_16_hunter_s_firefox_add_on_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[6,"16-hunter-s-firefox-add-on"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /help/articles/17-find-the-email-of-a-person(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_articles_17_find_the_email_of_a_person_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[6,"17-find-the-email-of-a-person"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /help/articles/18-gmail-integration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_articles_18_gmail_integration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[6,"18-gmail-integration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /help/articles/19-create-an-email-campaign(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_articles_19_create_an_email_campaign_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[6,"19-create-an-email-campaign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /help/articles/20-edit-or-remove-your-email-in-hunter(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_articles_20_edit_or_remove_your_email_in_hunter_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[6,"20-edit-or-remove-your-email-in-hunter"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /help/articles/2-hunter-s-chrome-extension(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_articles_2_hunter_s_chrome_extension_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[6,"2-hunter-s-chrome-extension"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /help/articles/3-find-email-addresses-for-a-domain(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_articles_3_find_email_addresses_for_a_domain_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[6,"3-find-email-addresses-for-a-domain"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /help/articles/4-salesforce-integration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_articles_4_salesforce_integration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[6,"4-salesforce-integration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /help/articles/5-bulk-domain-search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_articles_5_bulk_domain_search_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[6,"5-bulk-domain-search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /help/articles/6-bulk-email-verification(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_articles_6_bulk_email_verification_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[6,"6-bulk-email-verification"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /help/articles/7-bulk-email-finder(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_articles_7_bulk_email_finder_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[6,"7-bulk-email-finder"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /help/articles/8-pipedrive-integration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_articles_8_pipedrive_integration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[6,"8-pipedrive-integration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /help/articles/9-hubspot-integration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_articles_9_hubspot_integration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[6,"9-hubspot-integration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /help/articles/password-policy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_articles_password_policy_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[6,"password-policy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /help(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_center_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * (/:locale)/help/contact(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_contact_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"contact"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /help/faq_categories/10-email-verification(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_faq_categories_10_email_verification_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"faq_categories"],[2,[7,"/"],[2,[6,"10-email-verification"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /help/faq_categories/11-bulk-tasks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_faq_categories_11_bulk_tasks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"faq_categories"],[2,[7,"/"],[2,[6,"11-bulk-tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /help/faq_categories/12-leads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_faq_categories_12_leads_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"faq_categories"],[2,[7,"/"],[2,[6,"12-leads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /help/faq_categories/13-api(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_faq_categories_13_api_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"faq_categories"],[2,[7,"/"],[2,[6,"13-api"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /help/faq_categories/14-chrome-extension-and-firefox-add-on(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_faq_categories_14_chrome_extension_and_firefox_add_on_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"faq_categories"],[2,[7,"/"],[2,[6,"14-chrome-extension-and-firefox-add-on"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /help/faq_categories/15-google-sheets-add-on(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_faq_categories_15_google_sheets_add_on_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"faq_categories"],[2,[7,"/"],[2,[6,"15-google-sheets-add-on"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /help/faq_categories/16-integrations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_faq_categories_16_integrations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"faq_categories"],[2,[7,"/"],[2,[6,"16-integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /help/faq_categories/17-email-finder(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_faq_categories_17_email_finder_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"faq_categories"],[2,[7,"/"],[2,[6,"17-email-finder"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /help/faq_categories/3-general(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_faq_categories_3_general_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"faq_categories"],[2,[7,"/"],[2,[6,"3-general"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /help/faq_categories/4-account-profile(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_faq_categories_4_account_profile_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"faq_categories"],[2,[7,"/"],[2,[6,"4-account-profile"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /help/faq_categories/5-billing-pricing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_faq_categories_5_billing_pricing_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"faq_categories"],[2,[7,"/"],[2,[6,"5-billing-pricing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /help/faq_categories/6-subscriptions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_faq_categories_6_subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"faq_categories"],[2,[7,"/"],[2,[6,"6-subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /help/faq_categories/7-teams(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_faq_categories_7_teams_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"faq_categories"],[2,[7,"/"],[2,[6,"7-teams"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /help/faq_categories/8-requests-usage(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_faq_categories_8_requests_usage_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"faq_categories"],[2,[7,"/"],[2,[6,"8-requests-usage"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /help/faq_categories/9-domain-search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_faq_categories_9_domain_search_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"faq_categories"],[2,[7,"/"],[2,[6,"9-domain-search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /bulk-finders/:id/history(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const history_bulk_finder_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bulk-finders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /bulk-searches/:id/history(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const history_bulk_search_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bulk-searches"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /bulk-verifications/:id/history(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const history_bulk_verification_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bulk-verifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/:id/history(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const history_campaign_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /leads/:id/history(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const history_lead_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /home(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const home_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"home"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * (/:locale)/integrations/hubspot(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hubspot_integrations_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"hubspot"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/templates/import(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const import_email_templates_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /bulk-finders/:id/input_verification(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const input_verification_bulk_finder_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bulk-finders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"input_verification"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/:id/insights(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const insights_campaign_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"insights"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/integrations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"integrations"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/integrations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const integrations_root_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"integrations"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/intent-data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const intent_data_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"intent-data"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/internal/clear-cache(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_clear_cache_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"clear-cache"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/internal/custom_domains/images(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_custom_domains_images_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"custom_domains"],[2,[7,"/"],[2,[6,"images"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/internal/custom_domains/link_visits(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_custom_domains_link_visits_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"custom_domains"],[2,[7,"/"],[2,[6,"link_visits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/internal/custom_domains/pixel_visits(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_custom_domains_pixel_visits_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"custom_domains"],[2,[7,"/"],[2,[6,"pixel_visits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/internal/custom_domains/unsubscribe(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_custom_domains_unsubscribe_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"custom_domains"],[2,[7,"/"],[2,[6,"unsubscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/internal/last-blog-post(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_last_blog_post_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"last-blog-post"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /500(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_server_error_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"500"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * (/:locale)/internal/tax_id_validations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_tax_id_validations_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"tax_id_validations"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /invoices/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invoice_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /invoices/:invoice_id/receipt(.:format)
 * @param {any} invoice_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invoice_receipt_path = /*#__PURE__*/ __jsr.r({"invoice_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[3,"invoice_id"],[2,[7,"/"],[2,[6,"receipt"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /invoices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invoices_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"invoices"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /campaigns/issues(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const issues_campaigns_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"issues"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /search/last-domain-searches(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const last_domain_searches_search_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"last-domain-searches"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /bulk-verifications/:id/launch(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const launch_bulk_verification_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bulk-verifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"launch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /leads/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lead_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /leads/custom-attributes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lead_custom_attribute_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"custom-attributes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /leads/custom-attributes/:lead_custom_attribute_id/history(.:format)
 * @param {any} lead_custom_attribute_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lead_custom_attribute_history_path = /*#__PURE__*/ __jsr.r({"lead_custom_attribute_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"custom-attributes"],[2,[7,"/"],[2,[3,"lead_custom_attribute_id"],[2,[7,"/"],[2,[6,"history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /leads/custom-attributes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lead_custom_attributes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"custom-attributes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/api/lead-enrichment(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lead_enrichment_api_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"lead-enrichment"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /leads/tags/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lead_tag_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /leads/:lead_id/taggings/:id(.:format)
 * @param {any} lead_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lead_tagging_path = /*#__PURE__*/ __jsr.r({"lead_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[3,"lead_id"],[2,[7,"/"],[2,[6,"taggings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /leads/:lead_id/taggings(.:format)
 * @param {any} lead_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lead_taggings_path = /*#__PURE__*/ __jsr.r({"lead_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[3,"lead_id"],[2,[7,"/"],[2,[6,"taggings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /leads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leads_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"leads"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * (/:locale)/api/leads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leads_api_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"leads"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /lead/bulk(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leads_bulk_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lead"],[2,[7,"/"],[2,[6,"bulk"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /lead/companies/bulk_searches(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leads_bulk_searches_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lead"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"bulk_searches"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lead/companies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leads_companies_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lead"],[2,[7,"/"],[2,[6,"companies"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /lead/companies/bulks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leads_companies_bulks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lead"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"bulks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lead/companies/company_lists(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leads_companies_company_lists_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lead"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"company_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lead/companies/people(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leads_companies_people_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lead"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"people"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lead/companies/tags/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leads_companies_tag_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lead"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /lead/companies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leads_company_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lead"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lead/company-list/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leads_company_list_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lead"],[2,[7,"/"],[2,[6,"company-list"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lead/company-list/:company_list_id/lookalikes(.:format)
 * @param {any} company_list_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leads_company_list_lookalikes_path = /*#__PURE__*/ __jsr.r({"company_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lead"],[2,[7,"/"],[2,[6,"company-list"],[2,[7,"/"],[2,[3,"company_list_id"],[2,[7,"/"],[2,[6,"lookalikes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /lead/company-list/:company_list_id/memberships/:company_id(.:format)
 * @param {any} company_list_id
 * @param {any} company_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leads_company_list_membership_path = /*#__PURE__*/ __jsr.r({"company_list_id":{"r":true},"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lead"],[2,[7,"/"],[2,[6,"company-list"],[2,[7,"/"],[2,[3,"company_list_id"],[2,[7,"/"],[2,[6,"memberships"],[2,[7,"/"],[2,[3,"company_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /lead/company-list(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leads_company_lists_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lead"],[2,[7,"/"],[2,[6,"company-list"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /lead/companies/:company_id/taggings/:id(.:format)
 * @param {any} company_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leads_company_tagging_path = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lead"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"taggings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /lead/companies/:company_id/taggings(.:format)
 * @param {any} company_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leads_company_taggings_path = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lead"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"taggings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /lead/email_finder(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leads_email_finder_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lead"],[2,[7,"/"],[2,[6,"email_finder"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /lead/export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leads_export_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lead"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /leads-imports/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leads_import_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"leads-imports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /leads-imports/:leads_import_id/configuration(.:format)
 * @param {any} leads_import_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leads_import_configuration_path = /*#__PURE__*/ __jsr.r({"leads_import_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"leads-imports"],[2,[7,"/"],[2,[3,"leads_import_id"],[2,[7,"/"],[2,[6,"configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /leads-imports/:leads_import_id/history(.:format)
 * @param {any} leads_import_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leads_import_history_path = /*#__PURE__*/ __jsr.r({"leads_import_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"leads-imports"],[2,[7,"/"],[2,[3,"leads_import_id"],[2,[7,"/"],[2,[6,"history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /leads-imports/:leads_import_id/progress(.:format)
 * @param {any} leads_import_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leads_import_progress_path = /*#__PURE__*/ __jsr.r({"leads_import_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"leads-imports"],[2,[7,"/"],[2,[3,"leads_import_id"],[2,[7,"/"],[2,[6,"progress"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /leads-imports/:leads_import_id/settings(.:format)
 * @param {any} leads_import_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leads_import_settings_path = /*#__PURE__*/ __jsr.r({"leads_import_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"leads-imports"],[2,[7,"/"],[2,[3,"leads_import_id"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /leads-imports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leads_imports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"leads-imports"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /leads-lists/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leads_list_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"leads-lists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /leads-lists/bulk(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leads_list_bulk_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"leads-lists"],[2,[7,"/"],[2,[6,"bulk"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /leads-lists/:leads_list_id/favorite(.:format)
 * @param {any} leads_list_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leads_list_favorite_path = /*#__PURE__*/ __jsr.r({"leads_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"leads-lists"],[2,[7,"/"],[2,[3,"leads_list_id"],[2,[7,"/"],[2,[6,"favorite"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /leads-lists/:leads_list_id/favorite(.:format)
 * @param {any} leads_list_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leads_list_favorite_index_path = /*#__PURE__*/ __jsr.r({"leads_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"leads-lists"],[2,[7,"/"],[2,[3,"leads_list_id"],[2,[7,"/"],[2,[6,"favorite"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /leads-lists/favorite(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leads_list_favorites_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"leads-lists"],[2,[7,"/"],[2,[6,"favorite"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /leads-lists/folders/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leads_list_folder_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"leads-lists"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /leads-lists/folders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leads_list_folders_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"leads-lists"],[2,[7,"/"],[2,[6,"folders"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /leads-lists/:leads_list_id/history(.:format)
 * @param {any} leads_list_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leads_list_history_path = /*#__PURE__*/ __jsr.r({"leads_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"leads-lists"],[2,[7,"/"],[2,[3,"leads_list_id"],[2,[7,"/"],[2,[6,"history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /leads-lists/:leads_list_id/leads_count(.:format)
 * @param {any} leads_list_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leads_list_leads_count_path = /*#__PURE__*/ __jsr.r({"leads_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"leads-lists"],[2,[7,"/"],[2,[3,"leads_list_id"],[2,[7,"/"],[2,[6,"leads_count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /leads-lists/:leads_list_id/merge(.:format)
 * @param {any} leads_list_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leads_list_merge_index_path = /*#__PURE__*/ __jsr.r({"leads_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"leads-lists"],[2,[7,"/"],[2,[3,"leads_list_id"],[2,[7,"/"],[2,[6,"merge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /leads-lists(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leads_lists_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"leads-lists"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /lead/companies/signals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leads_signals_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lead"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"signals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lead/verify(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leads_verify_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lead"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /locations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const locations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"locations"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * (/:locale)/api/logo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const logo_api_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"logo"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /leads/lookalikes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookalikes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"lookalikes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /mailpool/check_domain(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mailpool_check_domain_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailpool"],[2,[7,"/"],[2,[6,"check_domain"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /mailpool/domain_suggestions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mailpool_domain_suggestions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailpool"],[2,[7,"/"],[2,[6,"domain_suggestions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /mailpool/events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mailpool_events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mailpool"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/integrations/make(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const make_integrations_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"make"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /managed_domain_owners(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const managed_domain_owners_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"managed_domain_owners"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /locations/mappings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mappings_locations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"locations"],[2,[7,"/"],[2,[6,"mappings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /notifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_all_as_read_notifications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /messages/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const message_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /message-attachments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const message_attachments_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"message-attachments"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /messages/drafts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const message_drafts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"drafts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /messages/:id/successful(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const message_successful_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"successful"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /message-templates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const message_template_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"message-templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /message-templates/drafts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const message_template_drafts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"message-templates"],[2,[7,"/"],[2,[6,"drafts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /message-templates/:message_template_id/history(.:format)
 * @param {any} message_template_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const message_template_history_path = /*#__PURE__*/ __jsr.r({"message_template_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"message-templates"],[2,[7,"/"],[2,[3,"message_template_id"],[2,[7,"/"],[2,[6,"history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /message-templates/:message_template_id/send-test(.:format)
 * @param {any} message_template_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const message_template_send_test_path = /*#__PURE__*/ __jsr.r({"message_template_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"message-templates"],[2,[7,"/"],[2,[3,"message_template_id"],[2,[7,"/"],[2,[6,"send-test"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /message-templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const message_templates_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"message-templates"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /messages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const messages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /leads/:id/messages(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const messages_lead_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /messaging-madness(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const messaging_madness_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"messaging-madness"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /messaging-madness-bracket(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const messaging_madness_bracket_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"messaging-madness-bracket"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /messaging-madness-contest-rules(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const messaging_madness_contest_rules_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"messaging-madness-contest-rules"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /campaigns/metrics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const metrics_campaigns_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"metrics"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /subscriptions/missing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const missing_subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"missing"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /mission-control
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"mission-control"]]);

/**
 * Generates rails route to
 * /mission-control/applications/:application_id/jobs/bulk_discards(.:format)
 * @param {any} application_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_bulk_discards_path = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"mission-control"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"bulk_discards"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mission-control/applications/:application_id/jobs/bulk_retries(.:format)
 * @param {any} application_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_bulk_retries_path = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"mission-control"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"bulk_retries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mission-control/applications/:application_id/jobs/:id(.:format)
 * @param {any} application_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_job_path = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"mission-control"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mission-control/applications/:application_id/jobs/:job_id/discard(.:format)
 * @param {any} application_id
 * @param {any} job_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_job_discard_path = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"job_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"mission-control"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"discard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mission-control/applications/:application_id/jobs/:job_id/dispatch(.:format)
 * @param {any} application_id
 * @param {any} job_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_job_dispatch_path = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"job_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"mission-control"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"dispatch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mission-control/applications/:application_id/jobs/:job_id/retry(.:format)
 * @param {any} application_id
 * @param {any} job_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_job_retry_path = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"job_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"mission-control"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mission-control/applications/:application_id/:status/jobs(.:format)
 * @param {any} application_id
 * @param {any} status
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_jobs_path = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"status":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"mission-control"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[3,"status"],[2,[7,"/"],[2,[6,"jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mission-control/applications/:application_id/queues/:id(.:format)
 * @param {any} application_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_queue_path = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"mission-control"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"queues"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mission-control/applications/:application_id/queues/:queue_id/pause(.:format)
 * @param {any} application_id
 * @param {any} queue_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_queue_pause_path = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"queue_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"mission-control"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"queues"],[2,[7,"/"],[2,[3,"queue_id"],[2,[7,"/"],[2,[6,"pause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mission-control/applications/:application_id/queues(.:format)
 * @param {any} application_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_queues_path = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"mission-control"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"queues"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mission-control/applications/:application_id/recurring_tasks/:id(.:format)
 * @param {any} application_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_recurring_task_path = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"mission-control"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"recurring_tasks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mission-control/applications/:application_id/recurring_tasks(.:format)
 * @param {any} application_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_recurring_tasks_path = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"mission-control"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"recurring_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mission-control/applications/:application_id/workers/:id(.:format)
 * @param {any} application_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_worker_path = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"mission-control"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"workers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mission-control/applications/:application_id/workers(.:format)
 * @param {any} application_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_workers_path = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"mission-control"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"workers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mission-control/jobs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_job_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"mission-control"]],[7,"/"]],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /mission-control/:status/jobs(.:format)
 * @param {any} status
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_jobs_path = /*#__PURE__*/ __jsr.r({"status":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"mission-control"]],[7,"/"]],[2,[3,"status"],[2,[7,"/"],[2,[6,"jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /mission-control/queues/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_queue_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"mission-control"]],[7,"/"]],[2,[6,"queues"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /mission-control/queues(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_queues_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"mission-control"]],[7,"/"]],[2,[6,"queues"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /mission-control/
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_root_path = /*#__PURE__*/ __jsr.r({}, [2,[2,[7,"/"],[6,"mission-control"]],[7,"/"]]);

/**
 * Generates rails route to
 * /search/multi-domain-search/emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const multi_domain_search_emails_search_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"multi-domain-search"],[2,[7,"/"],[2,[6,"emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /search/multi-domain-search/leads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const multi_domain_search_leads_search_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"multi-domain-search"],[2,[7,"/"],[2,[6,"leads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /search/multi-domain-search/reveal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const multi_domain_search_reveal_search_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"multi-domain-search"],[2,[7,"/"],[2,[6,"reveal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /search/multi-domain-search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const multi_domain_search_search_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"multi-domain-search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /oauth/authorize/native(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const native_oauth_authorization_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"authorize"],[2,[7,"/"],[2,[6,"native"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/account_exports/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_account_export_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"account_exports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/activity_logs/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_activity_log_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"activity_logs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/admin_user_notes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_admin_user_note_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"admin_user_notes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/api_keys/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_api_key_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"api_keys"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/banned_domains/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_banned_domain_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"banned_domains"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/bulk_finders/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_bulk_finder_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"bulk_finders"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/bulk_searches/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_bulk_search_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"bulk_searches"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/bulk_verifications/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_bulk_verification_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"bulk_verifications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/calls/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_call_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"calls"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/campaigns/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_campaign_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/campaign_email_accounts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_campaign_email_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaign_email_accounts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/campaign_recipients/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_campaign_recipient_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"campaign_recipients"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/cancellation_reasons/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_cancellation_reason_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"cancellation_reasons"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/claimed_emails/bulks/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_claimed_emails_bulk_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"claimed_emails"],[2,[7,"/"],[2,[6,"bulks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/connected_apps/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_connected_app_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"connected_apps"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/credit_cards/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_credit_card_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"credit_cards"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/custom_plans/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_custom_plan_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"custom_plans"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_templates/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_email_template_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_templates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_template_tags/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_email_template_tag_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_template_tags"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/follow_ups/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_follow_up_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"follow_ups"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/global_notifications/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_global_notification_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"global_notifications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/incoming_messages/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_incoming_message_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"incoming_messages"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/invoices/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_invoice_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"invoices"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ips/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_ip_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ips"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ip_visits/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_ip_visit_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ip_visits"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/leads/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_lead_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/lead_custom_attributes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_lead_custom_attribute_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"lead_custom_attributes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/leads_imports/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_leads_import_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"leads_imports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/leads_lists/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_leads_list_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"leads_lists"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/leads_list/dynamic_lists/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_leads_list_dynamic_list_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"leads_list"],[2,[7,"/"],[2,[6,"dynamic_lists"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/leads_list/static_lists/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_leads_list_static_list_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"leads_list"],[2,[7,"/"],[2,[6,"static_lists"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/link_visits/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_link_visit_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"link_visits"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/message_templates/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_message_template_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"message_templates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/new_accounts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_new_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"new_accounts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/onboarding_steps/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_onboarding_step_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"onboarding_steps"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/outgoing_messages/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_outgoing_message_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"outgoing_messages"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/outreach_domain_unsubscriptions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_outreach_domain_unsubscription_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"outreach_domain_unsubscriptions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/outreach_unsubscriptions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_outreach_unsubscription_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"outreach_unsubscriptions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/paused_subscriptions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_paused_subscription_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"paused_subscriptions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/pixel_visits/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_pixel_visit_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"pixel_visits"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/promo_codes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_promo_code_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"promo_codes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/requests/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_request_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"requests"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/requests_packs/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_requests_pack_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"requests_packs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/saved_leads/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_saved_lead_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"saved_leads"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/teams/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_team_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/teams/:team_id/entitlements/new(.:format)
 * @param {any} team_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_team_entitlement_path = /*#__PURE__*/ __jsr.r({"team_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[3,"team_id"],[2,[7,"/"],[2,[6,"entitlements"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/team_invites/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_team_invite_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"team_invites"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/team_permissions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_team_permission_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"team_permissions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/usages/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_usage_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"usages"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_user_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/user_data/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_user_datum_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"user_data"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/user_previous_emails/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_user_previous_email_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"user_previous_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/webhooks/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_admin_webhook_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api-documentation/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_documentation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api-documentation"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:api_version/leads/new(.:format)
 * @param {any} api_version
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_lead_path = /*#__PURE__*/ __jsr.r({"api_version":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"api_version"],[2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:api_version/leads_custom_attributes/new(.:format)
 * @param {any} api_version
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_leads_custom_attribute_path = /*#__PURE__*/ __jsr.r({"api_version":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"api_version"],[2,[7,"/"],[2,[6,"leads_custom_attributes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:api_version/leads_lists/new(.:format)
 * @param {any} api_version
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_api_leads_list_path = /*#__PURE__*/ __jsr.r({"api_version":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"api_version"],[2,[7,"/"],[2,[6,"leads_lists"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /billing-information/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_billing_information_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"billing-information"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /bulk-finders/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_bulk_finder_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"bulk-finders"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /bulk-searches/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_bulk_search_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"bulk-searches"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /bulk-verifications/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_bulk_verification_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"bulk-verifications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_campaign_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/:campaign_id/follow_ups/new(.:format)
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_campaign_follow_up_path = /*#__PURE__*/ __jsr.r({"campaign_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"follow_ups"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/unsubscriptions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_campaigns_unsubscription_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"unsubscriptions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /cancellation-reasons/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_cancellation_reason_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"cancellation-reasons"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/claim/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_claim_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"claim"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /companies-imports/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_companies_import_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"companies-imports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /companies-imports/:companies_import_id/settings/new(.:format)
 * @param {any} companies_import_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_companies_import_setting_path = /*#__PURE__*/ __jsr.r({"companies_import_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"companies-imports"],[2,[7,"/"],[2,[3,"companies_import_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /company-lists/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_company_list_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"company-lists"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /company-lists/folders/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_company_list_folder_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"company-lists"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /confirm-identity/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_confirm_identity_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"confirm-identity"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /credit-cards/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_credit_card_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"credit-cards"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /custom_domains/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_custom_domain_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"custom_domains"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /discover/people/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_discover_person_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"discover"],[2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /leads/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_lead_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /leads/custom-attributes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_lead_custom_attribute_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"custom-attributes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lead/companies/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_leads_company_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lead"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /lead/company-list/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_leads_company_list_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lead"],[2,[7,"/"],[2,[6,"company-list"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /leads-imports/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_leads_import_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"leads-imports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /leads-imports/:leads_import_id/settings/new(.:format)
 * @param {any} leads_import_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_leads_import_settings_path = /*#__PURE__*/ __jsr.r({"leads_import_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"leads-imports"],[2,[7,"/"],[2,[3,"leads_import_id"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /leads-lists/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_leads_list_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"leads-lists"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /leads-lists/folders/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_leads_list_folder_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"leads-lists"],[2,[7,"/"],[2,[6,"folders"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /leads-lists/:leads_list_id/merge/new(.:format)
 * @param {any} leads_list_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_leads_list_merge_path = /*#__PURE__*/ __jsr.r({"leads_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"leads-lists"],[2,[7,"/"],[2,[3,"leads_list_id"],[2,[7,"/"],[2,[6,"merge"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /messages/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_message_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /messages/drafts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_message_drafts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"drafts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /message-templates/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_message_template_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"message-templates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /message-templates/drafts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_message_template_drafts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"message-templates"],[2,[7,"/"],[2,[6,"drafts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /onboarding/subscriptions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_onboarding_subscription_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /paused-subscriptions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_paused_subscription_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"paused-subscriptions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_source_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /signals/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_signal_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"signals"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /connected-apps/smtp_imap/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_smtp_imap_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"connected-apps"],[2,[7,"/"],[2,[6,"smtp_imap"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /subscriptions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/technologies/domains_lists/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_technologies_domains_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"technologies"],[2,[7,"/"],[2,[6,"domains_lists"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_up"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/challenge/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_users_challenge_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"challenge"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /webhook_templates/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_webhook_template_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webhook_templates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /404(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const not_found_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"404"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /notifications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notification_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /notifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notifications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /oauth/authorize(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_authorization_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"authorize"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /oauth/discovery/keys(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_discovery_keys_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"discovery"],[2,[7,"/"],[2,[6,"keys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /.well-known/openid-configuration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_discovery_provider_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[8,"."],[2,[6,"well-known"],[2,[7,"/"],[2,[6,"openid-configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /.well-known/webfinger(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_discovery_webfinger_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[8,"."],[2,[6,"well-known"],[2,[7,"/"],[2,[6,"webfinger"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /oauth/introspect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_introspect_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"introspect"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /oauth/register(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_register_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"register"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /oauth/revoke(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_revoke_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"revoke"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /oauth/token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_token_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /oauth/userinfo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_userinfo_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"userinfo"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /onboarding/api(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_api_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"api"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /onboarding/campaigns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_campaigns_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /onboarding/chatgpt(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_chatgpt_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"chatgpt"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /onboarding/discover(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_discover_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"discover"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /onboarding/explore(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_explore_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"explore"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /onboarding/find_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_find_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"find_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /onboarding/intents_selection(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_intents_selection_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"intents_selection"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /onboarding/main_intent_selection(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_main_intent_selection_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"main_intent_selection"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /onboarding/skip-upgrade(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_skip_upgrade_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"skip-upgrade"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /onboarding/steps(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_steps_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"steps"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /onboarding/team_creation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_team_creation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"team_creation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /onboarding/team_selection(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_team_selection_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"team_selection"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /onboarding/teams(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_teams_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"teams"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /onboarding/verify_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_verify_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[2,[6,"verify_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /operations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const operation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"operations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /operations/:operation_id/cancel(.:format)
 * @param {any} operation_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const operation_cancel_path = /*#__PURE__*/ __jsr.r({"operation_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"operations"],[2,[7,"/"],[2,[3,"operation_id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /operations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const operations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"operations"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /operations/read(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const operations_read_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"operations"],[2,[7,"/"],[2,[6,"read"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/our-data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const our_data_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"our-data"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/our-data/chart(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const our_data_chart_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"our-data"],[2,[7,"/"],[2,[6,"chart"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /email_accounts/:id/outlook_display_name(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const outlook_display_name_email_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"email_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"outlook_display_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/integrations/outlook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const outlook_integrations_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"outlook"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/outreach(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const outreach_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"outreach"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /subscriptions/overage-requests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const overage_requests_subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"overage-requests"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /subscriptions/overdue-invoices(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const overdue_invoices_subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"overdue-invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/:id/pause(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pause_campaign_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /paused-subscriptions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paused_subscription_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"paused-subscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /paused-subscriptions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paused_subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"paused-subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * (/:locale)/integrations/pipedrive(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pipedrive_integrations_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"pipedrive"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/plan-calculator(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const plan_calculator_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"plan-calculator"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /postmark/events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const postmark_events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"postmark"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/press(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const press_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"press"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /bulk-searches/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_bulk_search_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bulk-searches"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /bulk-verifications/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_bulk_verification_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bulk-verifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /signals/preview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_signals_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"signals"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/pricing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pricing_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"pricing"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /pricing-update-04-2023(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pricing_update_04_2023_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pricing-update-04-2023"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /privacy-policy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const privacy_policy_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"privacy-policy"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /privacy-policy/california(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const privacy_policy_california_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"privacy-policy"],[2,[7,"/"],[2,[6,"california"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /bulk-finders/:id/progress(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const progress_bulk_finder_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bulk-finders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"progress"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /bulk-verifications/:id/progress(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const progress_bulk_verification_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bulk-verifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"progress"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_path = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_proxy_path = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/incinerate(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_incinerate_path = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"incinerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/reroute(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_reroute_path = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"reroute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_sources_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/direct_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_direct_uploads_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_key/*filename(.:format)
 * @param {any} encoded_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_disk_service_path = /*#__PURE__*/ __jsr.r({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mailgun/inbound_emails/mime(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mailgun_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"mime"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_health_check_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/postmark/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_postmark_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"postmark"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/relay/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_relay_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"relay"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/sendgrid/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_sendgrid_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"sendgrid"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/redirect/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_path = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/proxy/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_proxy_path = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ready(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ready_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ready"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /recover-revealed-emails-modal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recover_revealed_emails_modal_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"recover-revealed-emails-modal"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /search/:domain/related_companies(.:format)
 * @param {any} domain
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const related_companies_search_index_path = /*#__PURE__*/ __jsr.r({"domain":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[3,"domain"],[2,[7,"/"],[2,[6,"related_companies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /messages/:id/reply(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reply_message_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reply"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /request-more-credits(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const request_more_credits_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"request-more-credits"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /requests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const requests_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"requests"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /requests_packs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const requests_packs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"requests_packs"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/challenge/reset(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_users_challenge_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"challenge"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /bulk-finders/:id/restore(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restore_bulk_finder_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bulk-finders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"restore"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /bulk-searches/:id/restore(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restore_bulk_search_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bulk-searches"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"restore"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /bulk-verifications/:id/restore(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restore_bulk_verification_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bulk-verifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"restore"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /subscriptions/restore(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restore_subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"restore"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /leads/lookalikes/reveal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reveal_lookalikes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"lookalikes"],[2,[7,"/"],[2,[6,"reveal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /robot(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const robot_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"robot"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /(:locale)(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const root_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[7,"/"],[2,[1,[3,"locale"]],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * (/:locale)/integrations/salesforce(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const salesforce_integrations_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"salesforce"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /leads/lookalikes/save_lead(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const save_lead_lookalikes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"lookalikes"],[2,[7,"/"],[2,[6,"save_lead"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /search/companies/save(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const save_search_companies_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"save"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /search/companies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_companies_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"companies"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /lead/companies/search_entries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_entries_leads_companies_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lead"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"search_entries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /leads/lookalikes/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_lookalikes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"lookalikes"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /security-bounty-program(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const security_bounty_program_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"security-bounty-program"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /security-policy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const security_policy_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"security-policy"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /campaigns/sequence(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sequence_campaigns_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"sequence"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_campaigns_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /leads/settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_leads_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/sheets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sheets_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"sheets"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/sheets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sheets_root_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"sheets"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /connected-apps/:provider(.:format)
 * @param {any} provider
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const show_connected_apps_path = /*#__PURE__*/ __jsr.r({"provider":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"connected-apps"],[2,[7,"/"],[2,[3,"provider"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sidekiq
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sidekiq_web_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"sidekiq"]]);

/**
 * Generates rails route to
 * /signals/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signal_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"signals"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /signals/:signal_id/bulk_searches(.:format)
 * @param {any} signal_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signal_bulk_searches_path = /*#__PURE__*/ __jsr.r({"signal_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"signals"],[2,[7,"/"],[2,[3,"signal_id"],[2,[7,"/"],[2,[6,"bulk_searches"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /signals/:signal_id/duplicate(.:format)
 * @param {any} signal_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signal_duplicate_path = /*#__PURE__*/ __jsr.r({"signal_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"signals"],[2,[7,"/"],[2,[3,"signal_id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /signals/:signal_id/new_items(.:format)
 * @param {any} signal_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signal_new_items_path = /*#__PURE__*/ __jsr.r({"signal_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"signals"],[2,[7,"/"],[2,[3,"signal_id"],[2,[7,"/"],[2,[6,"new_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /signals/:signal_id/pause(.:format)
 * @param {any} signal_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signal_pause_path = /*#__PURE__*/ __jsr.r({"signal_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"signals"],[2,[7,"/"],[2,[3,"signal_id"],[2,[7,"/"],[2,[6,"pause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /signals/:signal_id/reaction(.:format)
 * @param {any} signal_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signal_reaction_path = /*#__PURE__*/ __jsr.r({"signal_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"signals"],[2,[7,"/"],[2,[3,"signal_id"],[2,[7,"/"],[2,[6,"reaction"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /signals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signals_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"signals"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /email_accounts/:id/signature(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signature_email_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"email_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"signature"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /sitemaps/email-templates.xml.gz(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sitemaps_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sitemaps"],[2,[7,"/"],[2,[6,"email-templates"],[2,[8,"."],[2,[6,"xml"],[2,[8,"."],[2,[6,"gz"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /connected-apps/smtp_imap/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const smtp_imap_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"connected-apps"],[2,[7,"/"],[2,[6,"smtp_imap"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /connected-apps/smtp_imap/:smtp_imap_id/connection_check(.:format)
 * @param {any} smtp_imap_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const smtp_imap_connection_check_index_path = /*#__PURE__*/ __jsr.r({"smtp_imap_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"connected-apps"],[2,[7,"/"],[2,[6,"smtp_imap"],[2,[7,"/"],[2,[3,"smtp_imap_id"],[2,[7,"/"],[2,[6,"connection_check"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /connected-apps/smtp_imap(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const smtp_imap_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"connected-apps"],[2,[7,"/"],[2,[6,"smtp_imap"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/integrations/smtp-imap(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const smtp_imap_integrations_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"smtp-imap"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /connected-apps/smtp_imap/:smtp_imap_id/reconnect(.:format)
 * @param {any} smtp_imap_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const smtp_imap_reconnect_index_path = /*#__PURE__*/ __jsr.r({"smtp_imap_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"connected-apps"],[2,[7,"/"],[2,[6,"smtp_imap"],[2,[7,"/"],[2,[3,"smtp_imap_id"],[2,[7,"/"],[2,[6,"reconnect"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /spam-policy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spam_policy_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"spam-policy"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /campaigns/:id/follow-ups/:follow_up_id/spam-score(.:format)
 * @param {any} id
 * @param {any} follow_up_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spam_score_campaign_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"follow_up_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"follow-ups"],[2,[7,"/"],[2,[3,"follow_up_id"],[2,[7,"/"],[2,[6,"spam-score"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /special-offer(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const special_offer_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"special-offer"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const status_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /email_accounts/statuses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statuses_email_accounts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_accounts"],[2,[7,"/"],[2,[6,"statuses"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /stripe/events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stripe_events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"stripe"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /subprocessors(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subprocessors_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subprocessors"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /subscription(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscription_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscription"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /email_accounts/:id/subscription(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscription_email_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"email_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"subscription"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email_accounts/:id/subscription/restore(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscription_restore_email_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"email_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"subscription"],[2,[7,"/"],[2,[6,"restore"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /subscriptions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /summer-starter(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const summer_starter_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"summer-starter"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /leads/:provider/synchronize-all(.:format)
 * @param {any} provider
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const synchronize_all_leads_path = /*#__PURE__*/ __jsr.r({"provider":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[3,"provider"],[2,[7,"/"],[2,[6,"synchronize-all"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /leads/:id/synchronize(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const synchronize_lead_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"leads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"synchronize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/total-addressable-market-calculator(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tam_calculator_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"total-addressable-market-calculator"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * /subscriptions/tax-rate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tax_rate_subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"tax-rate"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /teams(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teams_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"teams"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /teams/join/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teams_confirm_join_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"join"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /teams/invites/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teams_invite_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"invites"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /teams/invite_by_domain(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teams_invite_by_domain_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"invite_by_domain"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /teams/invite_link(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teams_invite_link_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"invite_link"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /teams/invites(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teams_invites_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"invites"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /teams/join/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teams_join_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"join"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /teams/members/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teams_member_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /teams/join/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teams_reject_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"join"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /teams/roles/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teams_role_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teams"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /techlookup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const techlookup_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"techlookup"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /technologies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const technologies_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"technologies"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * (/:locale)/technologies/domains_lists/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const technologies_domains_list_path = /*#__PURE__*/ __jsr.r({"locale":{},"id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"technologies"],[2,[7,"/"],[2,[6,"domains_lists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/technologies/domains_lists/:domains_list_id/verification(.:format)
 * @param {any} domains_list_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const technologies_domains_list_verification_path = /*#__PURE__*/ __jsr.r({"locale":{},"domains_list_id":{"r":true},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"technologies"],[2,[7,"/"],[2,[6,"domains_lists"],[2,[7,"/"],[2,[3,"domains_list_id"],[2,[7,"/"],[2,[6,"verification"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/technologies/domains_lists(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const technologies_domains_lists_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"technologies"],[2,[7,"/"],[2,[6,"domains_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /terms-of-service(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const terms_of_service_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"terms-of-service"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /the-state-of-cold-email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const the_state_of_cold_email_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"the-state-of-cold-email"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /the-state-of-cold-email-report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const the_state_of_cold_email_report_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"the-state-of-cold-email-report"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /trial/:api_version/domain-search(.:format)
 * @param {any} api_version
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trial_domain_search_path = /*#__PURE__*/ __jsr.r({"api_version":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"trial"],[2,[7,"/"],[2,[3,"api_version"],[2,[7,"/"],[2,[6,"domain-search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /trial/:api_version/email-finder(.:format)
 * @param {any} api_version
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trial_email_finder_path = /*#__PURE__*/ __jsr.r({"api_version":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"trial"],[2,[7,"/"],[2,[3,"api_version"],[2,[7,"/"],[2,[6,"email-finder"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /trial/:api_version/email-verifier(.:format)
 * @param {any} api_version
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trial_email_verifier_path = /*#__PURE__*/ __jsr.r({"api_version":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"trial"],[2,[7,"/"],[2,[3,"api_version"],[2,[7,"/"],[2,[6,"email-verifier"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /recede_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_recede_historical_location_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"recede_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /refresh_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_refresh_historical_location_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"refresh_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /resume_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_resume_historical_location_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"resume_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * (/:locale)/chrome/uninstall(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uninstall_chrome_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"chrome"],[2,[7,"/"],[2,[6,"uninstall"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/extension/uninstall/confirm(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uninstall_confirm_extension_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"extension"],[2,[7,"/"],[2,[6,"uninstall"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/edge/uninstall(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uninstall_edge_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"edge"],[2,[7,"/"],[2,[6,"uninstall"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/extension/uninstall(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uninstall_extension_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"extension"],[2,[7,"/"],[2,[6,"uninstall"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/firefox/uninstall(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uninstall_firefox_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"firefox"],[2,[7,"/"],[2,[6,"uninstall"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /422(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unprocessable_entity_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"422"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /campaigns/inbox/:id/unread(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unread_campaigns_inbox_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"inbox"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unread"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /unsubscribe/:payload(.:format)
 * @param {any} payload
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unsubscribe_path = /*#__PURE__*/ __jsr.r({"payload":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"unsubscribe"],[2,[7,"/"],[2,[3,"payload"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /connected-apps/:provider(.:format)
 * @param {any} provider
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_connected_apps_path = /*#__PURE__*/ __jsr.r({"provider":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"connected-apps"],[2,[7,"/"],[2,[3,"provider"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_token(.:format)
 * @param {any} encoded_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_rails_disk_service_path = /*#__PURE__*/ __jsr.r({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /upgrade-required(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upgrade_required_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"upgrade-required"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * (/:locale)/welcome/upgrade(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upgrade_welcome_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"welcome"],[2,[7,"/"],[2,[6,"upgrade"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /:api_version/leads(.:format)
 * @param {any} api_version
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upsert_api_leads_path = /*#__PURE__*/ __jsr.r({"api_version":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[3,"api_version"],[2,[7,"/"],[2,[6,"leads"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /usage(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usage_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"usage"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /usage/details(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usage_details_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"usage"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /usage/details/graphs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usage_details_graphs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"usage"],[2,[7,"/"],[2,[6,"details"],[2,[7,"/"],[2,[6,"graphs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email_accounts/:id/usage(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usage_email_account_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"email_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"usage"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /email_accounts/usage(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usage_email_accounts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"email_accounts"],[2,[7,"/"],[2,[6,"usage"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /usage/history(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usage_history_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"usage"],[2,[7,"/"],[2,[6,"history"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /usage/history/export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usage_history_export_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"usage"],[2,[7,"/"],[2,[6,"history"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /usage/history/usages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usage_history_usages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"usage"],[2,[7,"/"],[2,[6,"history"],[2,[7,"/"],[2,[6,"usages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /usage/requests_history(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usage_requests_history_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"usage"],[2,[7,"/"],[2,[6,"requests_history"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user_datas(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_datas_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user_datas"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /join/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_join_path = /*#__PURE__*/ __jsr.r({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"join"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/accept-terms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_accept_terms_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"accept-terms"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/challenge/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_challenge_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"challenge"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/challenge(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_challenge_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"challenge"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/change-email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_change_email_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"change-email"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/check-your-inbox(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_check_your_inbox_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"check-your-inbox"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/complete-profile(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_complete_profile_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"complete-profile"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/email-accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_email_accounts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"email-accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/pre-registrations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_pre_registrations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"pre-registrations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/pre-registrations/check-email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_pre_registrations_check_email_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"pre-registrations"],[2,[7,"/"],[2,[6,"check-email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/pre-registrations/save-email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_pre_registrations_save_email_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"pre-registrations"],[2,[7,"/"],[2,[6,"save-email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/referral-code(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_referral_code_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"referral-code"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/registration(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"registration"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/registration-blocked(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_registration_blocked_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"registration-blocked"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_root_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_settings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/sso(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_sso_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sso"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/subprocessors-subscriptions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_subprocessors_subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"subprocessors-subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/update-cookies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_update_cookies_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"update-cookies"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/update-notifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_update_notifications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"update-notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/validate-email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_validate_email_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"validate-email"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /v1/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const v1_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /v1/account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const v1_account_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"account"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api-documentation/v1(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const v1_api_documentation_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api-documentation"],[2,[7,"/"],[2,[6,"v1"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /v1/email-count(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const v1_email_count_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"email-count"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /v1/lead(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const v1_lead_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"lead"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /v1/verify(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const v1_verify_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api-documentation/v2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const v2_api_documentation_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api-documentation"],[2,[7,"/"],[2,[6,"v2"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/change-email/validate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validate_users_change_email_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"change-email"],[2,[7,"/"],[2,[6,"validate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /validation/linkedin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validation_linkedin_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"validation"],[2,[7,"/"],[2,[6,"linkedin"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /validation/phone-number(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validation_phone_number_root_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"validation"],[2,[7,"/"],[2,[6,"phone-number"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /validation/phone-number/step_1(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validation_phone_number_step_1_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"validation"],[2,[7,"/"],[2,[6,"phone-number"],[2,[7,"/"],[2,[6,"step_1"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /validation/phone-number/step_2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validation_phone_number_step_2_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"validation"],[2,[7,"/"],[2,[6,"phone-number"],[2,[7,"/"],[2,[6,"step_2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /campaigns/:campaign_id/audience/verify(.:format)
 * @param {any} campaign_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verify_campaign_audience_path = /*#__PURE__*/ __jsr.r({"campaign_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /verify(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verify_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /warmbox/events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const warmbox_events_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"warmbox"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /webhook_templates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhook_template_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"webhook_templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /webhook_templates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhook_templates_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webhook_templates"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /webhooks/customerio-Wz1fb0z2Mbg0wYsFsg0wY(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooks_customerio_Wz1fb0z2Mbg0wYsFsg0wY_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"customerio-Wz1fb0z2Mbg0wYsFsg0wY"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /webhooks/intercom-wpeEuoxpcHKIDOM4AJ73u3O(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooks_intercom_wpeEuoxpcHKIDOM4AJ73u3O_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"intercom-wpeEuoxpcHKIDOM4AJ73u3O"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /webhooks/internal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooks_internal_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"internal"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /webhooks/planetscale-7kX9mPqR2vY8nZ3wL5jH(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooks_planetscale_7kX9mPqR2vY8nZ3wL5jH_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"planetscale-7kX9mPqR2vY8nZ3wL5jH"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /webhooks/rewardful-dz3pX5K7Y2adc90asj56g(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooks_rewardful_dz3pX5K7Y2adc90asj56g_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"rewardful-dz3pX5K7Y2adc90asj56g"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /webhooks/satismeter-BHdpgYdrk(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooks_satismeter_BHdpgYdrk_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"satismeter-BHdpgYdrk"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/webinars(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webinars_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"webinars"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/chrome/welcome(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const welcome_chrome_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"chrome"],[2,[7,"/"],[2,[6,"welcome"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/edge/welcome(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const welcome_edge_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"edge"],[2,[7,"/"],[2,[6,"welcome"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/welcome/find-business-emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const welcome_find_business_emails_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"welcome"],[2,[7,"/"],[2,[6,"find-business-emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/welcome/find-emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const welcome_find_emails_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"welcome"],[2,[7,"/"],[2,[6,"find-emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/firefox/welcome(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const welcome_firefox_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"firefox"],[2,[7,"/"],[2,[6,"welcome"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/welcome(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const welcome_index_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"welcome"],[1,[2,[8,"."],[3,"format"]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/sheets/welcome(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const welcome_sheets_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"sheets"],[2,[7,"/"],[2,[6,"welcome"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /subscriptions/welcome(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const welcome_subscriptions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"welcome"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/welcome/verify-emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const welcome_verify_emails_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"welcome"],[2,[7,"/"],[2,[6,"verify-emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/integrations/zapier(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const zapier_integrations_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"zapier"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * (/:locale)/integrations/zoho(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const zoho_integrations_path = /*#__PURE__*/ __jsr.r({"locale":{},"format":{}}, [2,[1,[2,[7,"/"],[3,"locale"]]],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"zoho"],[1,[2,[8,"."],[3,"format"]]]]]]]]);

